
const digest = '8aa410452e0906ec45e31e9fc8e393f3bd65bb0d4a3de7067fa6dc863da120b5';
const classes = {"wrapper":"_wrapper_wo2a5_1","backdrop":"_backdrop_wo2a5_16","sm":"_sm_wo2a5_25","md":"_md_wo2a5_30","lg":"_lg_wo2a5_35","xl":"_xl_wo2a5_40","modal":"_modal_wo2a5_45","fullScreen":"_fullScreen_wo2a5_64","header":"_header_wo2a5_69","headerTitle":"_headerTitle_wo2a5_78","close":"_close_wo2a5_90","content":"_content_wo2a5_99","maxHeight":"_maxHeight_wo2a5_104","contentScroll":"_contentScroll_wo2a5_108"};
const css = `._wrapper_wo2a5_1 {
  position: fixed;
  z-index: 1100;
  background: rgba(6, 42, 96, 0.9);
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 100vw;
  max-height: 100vh;
}

._backdrop_wo2a5_16 {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: -1;
}

._sm_wo2a5_25 {
  width: 300px !important;
  max-width: 300px !important;
}

._md_wo2a5_30 {
  width: 500px !important;
  max-width: 500px !important;
}

._lg_wo2a5_35 {
  width: 800px !important;
  max-width: 800px !important;
}

._xl_wo2a5_40 {
  width: 1140px !important;
  max-width: 1140px !important;
}

._modal_wo2a5_45 {
  background: #ffffff;
  width: fit-content;
  -webkit-box-shadow: 0px 0px 41px 9px rgba(0, 0, 0, 0.2);
  -moz-box-shadow: 0px 0px 41px 9px rgba(0, 0, 0, 0.2);
  box-shadow: 0px 0px 41px 9px rgba(0, 0, 0, 0.2);
  min-width: 600px;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  max-width: calc(100vw - 30px);
  max-height: calc(100vh - 30px);
}

@media (max-width: 600px) {
  ._modal_wo2a5_45 {
    min-width: 100%;
  }
}
._fullScreen_wo2a5_64 {
  width: calc(100vw - 40px);
  height: calc(100vh - 40px);
}

._header_wo2a5_69 {
  padding: 34px 24px;
  border-bottom: 1px solid #eaedf3;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

._headerTitle_wo2a5_78 {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  font-family: Poppins, sans-serif;
  color: #212357;
  font-weight: 600;
  font-size: 18px;
  padding-right: 25px;
}

._close_wo2a5_90 {
  font-family: Poppins, sans-serif;
  font-weight: 500;
  font-size: 14px;
  color: #d81616;
  cursor: pointer;
  text-decoration: underline;
}

._content_wo2a5_99 {
  padding: 34px 24px;
  overflow-y: auto;
}

._maxHeight_wo2a5_104 {
  height: calc(100vh - 180px);
}

._contentScroll_wo2a5_108 {
  overflow-y: scroll;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  